import {
  Button,
  Center,
  ColorPicker,
  Flex,
  Modal,
  NumberInput,
  Radio,
  Select,
  Text,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { useDisclosure } from "@mantine/hooks";

import React, { useEffect, useState } from "react";

import DraggableArea from "./DraggableArea";
import ObjectManagement from "./ObjectManagement";
import ObjectItem from "./ObjectItem";
import { getObj, insertObj } from "../apis/adminSiteEditApis";
import ObjectAddEditForm from "./ObjectAddEditForm";
import { getDeviceList } from "pages/Admin/Device/apis/adminDeviceApis";
import { getLibraryList } from "pages/Admin/Library/apis/adminLibraryApis";
import { useLocation, useNavigate } from "react-router-dom";
import ThresholdForm from "./ThresholdForm";
import { getPathname } from "utils/getPathname";

function SiteEditForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const objectId = getPathname();

  const { group_id, field_id, bsd_id, user_id } = location.state;

  const [objectList, setObjectList] = useState([]);
  const [imgyeList, setImgyeList] = useState([]);

  const [objectManagementOpened, objectManagementControl] =
    useDisclosure(false);

  const handleObjectManagementOpen = () => objectManagementControl.open();
  const handleObjectManagementClose = () => objectManagementControl.close();

  const [objectAddEditModalOpened, objectAddEditModalControl] =
    useDisclosure(false);

  const [objectDefaultValue, setObjectDefaultValue] = useState();

  const handleObjectAddEditModalOpen = (id) => {
    if (id) {
      setObjectDefaultValue(objectList.find((object) => object.obj_id === id));
    } else {
      setObjectDefaultValue();
    }
    objectAddEditModalControl.open();
  };
  const handleObjectAddEditModalClose = () => objectAddEditModalControl.close();

  const [handleThresholdOpened, handleThresholdControl] = useDisclosure(false);
  const [selectedRecords, setSelectedRecords] = useState([]);

  const handleThresholdOpen = () => {
    if (selectedRecords[0].bsd_id) handleThresholdControl.open();
    else alert("해당 오브젝트의 장치를 설정해주세요.");
  };

  const handleThresholdClose = () => handleThresholdControl.close();

  const insertObject = () => {
    insertObj(objectList, imgyeList).then((res) => console.log(res));
    // navigate("/admin/site_edit");
  };

  const fieldsTypeOptions = [
    { value: "1", label: "상태감시" },
    { value: "2", label: "CCTV" },
    { value: "4", label: "통신" },  //add by bjkim6114 2023.11.17  
  ];

  const radioAltTextOptions = [
    { value: "Y", label: "Yes" },
    { value: "N", label: "No" },
  ];

  const [selectedFieldsType, setSelectedFieldsType] = useState();
  const [selectedAltTextOption, setSelectedAltTextOption] = useState();

  const [libraryList, setLibraryList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);

  useEffect(() => {
    getObj(objectId).then((res) => setObjectList(res.view));
  }, []);

  useEffect(() => {
    getLibraryList(100, 1,group_id).then((res) => {
      const mappedData = res.map((item) => ({
        value: item.download_link,
        label: item.title,
      }));
      setLibraryList(mappedData);
    });
  }, []);

  useEffect(() => {
    getDeviceList(100, 1).then((res) => {
      const mappedData = res.map((item) => ({
        value: item.bsd_id,
        label: item.bsd_nm,
      }));
      setDeviceList(mappedData);
    });
  }, []);

  const SelectFieldsType = (props) => {
    const { field, name, defaultValue } = props;
    setSelectedFieldsType(field.value);
    return (
      <Select
        label={name}
        data={fieldsTypeOptions}
        value={field.value}
        defaultValue={defaultValue}
        {...field}
      />
    );
  };

  const RadioAltText = (props) => {
    const { field, name, defaultValue } = props;
    if (name === "대체텍스트 여부") setSelectedAltTextOption(field.value);
    return (
      <Radio.Group label={name} defaultValue={defaultValue} {...field}>
        <Flex gap="md">
          {radioAltTextOptions.map((option) => (
            <>
              <Radio
                key={option.value}
                value={option.value}
                label={option.label}
              />
            </>
          ))}
        </Flex>
      </Radio.Group>
    );
  };

  const SelectLibrary = (props) => {
    const { field, name } = props;
    return (
      <Select label={name} data={libraryList} value={field.value} {...field} />
    );
  };

  const SelectDevice = (props) => {
    const { field, name } = props;
    return (
      <Select label={name} data={deviceList} value={field.value} {...field} />
    );
  };

  const SelectFontSize = (props) => {
    const { field, name, defaultValue, disabled } = props;
    const handleChange = (value) => {
      // "px"를 추가하여 값을 저장
      field.onChange(`${value}px`);
    };

    return (
      <NumberInput
        label={name}
        value={parseInt(field.value)}
        onChange={handleChange}
        defaultValue={defaultValue}
        disabled={disabled}
        formatter={(value) => `${value} px`}
        max={100}
      />
    );
  };

  const SelectColor = (props) => {
    const { field, name, disabled } = props;
    return (
      <>
        <>
          <Text size="sm">{name}</Text>
          <Center>
            {!disabled ? (
              <Flex direction="column" align="center" gap={1}>
                <ColorPicker
                  size="xs"
                  value={field.value}
                  onChange={field.onChange}
                  disabled={disabled}
                />
                <Flex gap={1}>
                  <Text size="md" fw={500} style={{ color: field.value }}>
                    {field.value}
                  </Text>
                </Flex>
              </Flex>
            ) : (
              <Text fz="sm" c="dimmed">
                대체텍스트를 'YES'로 바꿔주세요.
              </Text>
            )}
          </Center>
        </>
      </>
    );
  };

  const fields = [
    {
      key: "obj_nm",
      name: "오브젝트명",
      type: "text",
      options: "validate",
    },
    {
      key: "obj_seq",
      name: "순서",
      type: "number",
      options: "validate",
      defaultValue: objectList.length + 1,
    },
    {
      key: "type",
      name: "유형",
      type: "etc",
      component: SelectFieldsType,
      defaultValue: "1",
    },
    {
      key: "cctv_url",
      name: "CCTV URL",
      type: "text",
      disabled: selectedFieldsType === "2" ? false : true,
      options: selectedFieldsType === "2" && "validate",
    },
    {
      key: "t_yn",
      name: "대체텍스트 여부",
      type: "etc",
      component: RadioAltText,
      defaultValue: "N",
    },
    {
      key: "t_cont",
      name: "대체텍스트",
      type: "text",
      disabled: selectedAltTextOption === "Y" ? false : true,
      options: selectedAltTextOption === "Y" && "validate",
    },
    {
      key: "t_sort",
      name: "텍스트 정렬조건",
      type: "select",
      disabled: selectedAltTextOption === "Y" ? false : true,
      options: ["Center", "Left", "Right"],
    },
    {
      key: "t_font_s",
      name: "폰트크기",
      type: "etc",
      disabled: selectedAltTextOption === "Y" ? false : true,
      component: SelectFontSize,
      defaultValue: 12,
    },
    {
      key: "t_font_c",
      name: "폰트색상",
      type: "etc",
      disabled: selectedAltTextOption === "Y" ? false : true,
      component: SelectColor,
      defaultValue: "#000000",
    },
    {
      key: "t_cont_bg",
      name: "배경색상",
      type: "etc",
      disabled: selectedAltTextOption === "Y" ? false : true,
      component: SelectColor,
      defaultValue: "",
    },
    {
      key: "img_url",
      name: "라이브러리",
      type: "etc",
      component: SelectLibrary,
    },
    {
      key: "bsd_id",
      name: "장치",
      type: "etc",
      component: SelectDevice,
    },
    {
      key: "view_yn",
      name: "표시여부",
      type: "etc",
      component: RadioAltText,
      defaultValue: "Y",
    },
  ];

  const onSubmit = (e) => {
    const { bsd_id = "", ...rest } = e;

    const objectList = {
      ...rest,
      bsd_id,
      obj_id: `OBJ-${e.obj_nm}`,
      field_id,
      group_id,
      user_id,
      // object_nm,
      top: objectDefaultValue ? objectDefaultValue.top : 0,
      left: objectDefaultValue ? objectDefaultValue.left : 0,
      width: objectDefaultValue ? objectDefaultValue.width : 30,
      height: objectDefaultValue ? objectDefaultValue.height : 30,
    };

    modals.openConfirmModal({
      title: "저장",
      children: <Center>저장 하시겠습니까?</Center>,
    //  centered: true,
      zIndex: 2050,
      labels: { confirm: "저장", cancel: "취소" },
      onConfirm: () => {
        if (objectDefaultValue) {
          setObjectList((prev) =>
            prev.filter((obj) => obj !== objectDefaultValue).concat(objectList)
          );
        } else {
          setObjectList((prev) => [...prev, objectList]);
        }
        // handleObjectAddEditModalClose();
      },
    });
  };

  const thresholdOnSubmit = (e) => {
    console.log(e);
    const { imgye_range, ...rest } = e;
    const defaultOptions = selectedRecords[0];
    const imgyeList = {
      obj_id: defaultOptions.obj_id,
      imgye_id: defaultOptions.obj_id,
      imgye_st: e.imgye_range[0],
      imgye_ed: e.imgye_range[1],
      ...rest,
    };

    modals.openConfirmModal({
      title: "저장",
      children: <Center>저장 하시겠습니까?</Center>,
   //   centered: true,
      zIndex: 2050,
      labels: { confirm: "저장", cancel: "취소" },
      onConfirm: () => {
        setImgyeList((prev) => [...prev, imgyeList]);
        handleThresholdClose();
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Button type="submit">저장</Button>
      </Center>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <Flex gap={15} style={{ width: "1600px" }}>
        <Button
          onClick={handleObjectManagementOpen}
          style={{
            margin: "10px 0px",
          }}
        >
          오브젝트 관리
        </Button>
        <Button
          onClick={insertObject}
          style={{
            margin: "10px 0px",
          }}
          type="submit"
          disabled={objectList.length === 0}
        >
          오브젝트 저장
        </Button>
      </Flex>
      <DraggableArea objectList={objectList} setObjectList={setObjectList}>
        {objectList?.map((object) => (
          <ObjectItem
            id={object.obj_id}
            object={object}
            handleObjectAddEditModalOpen={handleObjectAddEditModalOpen}
            setObjectDefaultValue={setObjectDefaultValue}
          />
        ))}
      </DraggableArea>
      <Modal
        opened={objectManagementOpened}
        onClose={handleObjectManagementClose}
        title="오브젝트 관리"
    //    centered
        size="xl"
        zIndex={2000}
      >
        <ObjectManagement
          handleObjectAddEditModalOpen={handleObjectAddEditModalOpen}
          handleThresholdOpen={handleThresholdOpen}
          objectList={objectList}
          setObjectList={setObjectList}
          selectedRecords={selectedRecords}
          setSelectedRecords={setSelectedRecords}
        />
      </Modal>
      <Modal
        opened={objectAddEditModalOpened}
        onClose={handleObjectAddEditModalClose}
        title="오브젝트 생성/수정"
     //   centered
        size="xl"
        zIndex={2010}
      >
        <ObjectAddEditForm
          fields={fields}
          onSubmit={onSubmit}
          submitButton={<SubmitButton />}
          defaultValues={objectDefaultValue}
        />
      </Modal>
      <Modal
        opened={handleThresholdOpened}
        onClose={handleThresholdClose}
        title="임계치 생성/수정"
        centered
        size="xl"
        zIndex={2010}
      >
        <ThresholdForm
          libraryList={libraryList}
          thresholdOnSubmit={thresholdOnSubmit}
          handleThresholdClose={handleThresholdClose}
          defaultValues={selectedRecords[0]}
        />
      </Modal>
    </div>
  );
}

export default SiteEditForm;
